import {
    DEFAULT_UPLOAD_SIZE,
    MAX_PART_SIZE,
    MAX_UPLOAD_CHUNK_SIZE,
} from '../consts';

// マルチパートアップロードの最適化されたチャンクサイズを返す
export function computeMultipartSize(fileSize: number): number {
    let chunksize = DEFAULT_UPLOAD_SIZE;
    let part = 1000;
    const PART_INCREMENT = 1.2;
    const SIZE_INCREMENT = 2;
    while (fileSize > chunksize * part) {
        if (part >= MAX_PART_SIZE && chunksize >= MAX_UPLOAD_CHUNK_SIZE) {
            break;
        }
        part = Math.min(MAX_PART_SIZE, Math.ceil(part * PART_INCREMENT));
        chunksize = Math.min(MAX_UPLOAD_CHUNK_SIZE, chunksize * SIZE_INCREMENT);
    }
    if (fileSize > part * chunksize) {
        return -1;
    }

    /*
    //for debug
    const chunkSizeMega = chunksize / 1024 / 1014;
    console.log('マルチパート分割', {
        fileSize,
        part,
        chunksize,
        chunkSizeMega,
    });
    */
    return chunksize;
}
